import { render } from "./SetUserPasswordView.vue?vue&type=template&id=e7d8bfc6"
import script from "./SetUserPasswordView.vue?vue&type=script&lang=js"
export * from "./SetUserPasswordView.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./SetUserPasswordView.vue?vue&type=style&index=0&id=e7d8bfc6&lang=scss&module=true"
cssModules["$style"] = style0
import "./SetUserPasswordView.vue?vue&type=style&index=1&id=e7d8bfc6&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__